import { useState, useEffect } from 'react';

export default function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/1d3f27554bfc02c8d70719ba9154a65f.jpg',
      title: '岡山市・倉敷市のリフォーム工事',
      subtitle: '地域密着25年の実績で安心施工をお約束',
      cta: '無料見積もり'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20bathroom%20renovation%20with%20modern%20fixtures%2C%20clean%20tiles%2C%20spa-like%20atmosphere%2C%20natural%20materials%2C%20contemporary%20design%2C%20luxury%20bathroom%20interior%2C%20professional%20installation&width=1200&height=600&seq=hero2&orientation=landscape',
      title: '水回りリフォームの専門家',
      subtitle: 'キッチン・バスルーム・トイレの快適空間づくり',
      cta: '施工事例を見る'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20Japanese%20bathroom%20interior%20design%20with%20clean%20lines%2C%20contemporary%20fixtures%2C%20bright%20natural%20lighting%2C%20elegant%20tile%20work%2C%20spacious%20layout%2C%20luxury%20spa%20atmosphere%2C%20professional%20renovation%20quality&width=1200&height=600&seq=hero3&orientation=landscape',
      title: '店舗工事・修繕工事も対応',
      subtitle: '飲食店から美容室まで幅広い実績',
      cta: 'お問い合わせ'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="relative h-screen min-h-[500px] sm:min-h-[600px] overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url('${slide.image}')` }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          </div>
          
          <div className="relative z-10 h-full flex items-center">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
                {slide.title}
              </h2>
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-6 sm:mb-8">
                {slide.subtitle}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
                <a
                  href="tel:086-012-3456"
                  className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line mr-2"></i>
                  お電話でのご相談
                </a>
                <a
                  href="#contact"
                  className="bg-white text-teal-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {slide.cta}
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 text-white p-2 sm:p-3 rounded-full transition-colors cursor-pointer"
        aria-label="前のスライド"
      >
        <i className="ri-arrow-left-line text-xl sm:text-2xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 text-white p-2 sm:p-3 rounded-full transition-colors cursor-pointer"
        aria-label="次のスライド"
      >
        <i className="ri-arrow-right-line text-xl sm:text-2xl"></i>
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 z-20 flex space-x-2 sm:space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white w-6 sm:w-8' : 'bg-white/50'
            }`}
            aria-label={`スライド${index + 1}へ移動`}
          ></button>
        ))}
      </div>
    </section>
  );
}
